import{a as e}from"./chunk-UGTDX6XE.mjs";import{b as m}from"./chunk-LSZKOVGW.mjs";import{j as o,k as r}from"./chunk-GTEBSQTL.mjs";var i=new o({locale:[e,m,r]});export{i as a};
